import React, { useState, useCallback, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { visitStep } from './steps'
import { size, split, filter } from 'lodash'
import FormComponent from '../utils/form'
import { UserContext } from '../utils/UserContext'
import { StepContext } from '../utils/stepContext'
import { PropertyContext } from '../utils/PropertyContext'

const Visit = (props) => {
  const { t } = useTranslation()
  const { isUserValid, user } = useContext(UserContext)
  const [steps, setSteps] = useState(visitStep)
  const { property } = useContext(PropertyContext)
  const [error, setError] = useState({})
  const [payload, setPayload] = useState({})
  const { step, incrementStep, setSteps: contextSetSteps } = useContext(StepContext)
  useEffect(() => {
    contextSetSteps(steps)
  }, [steps])
  const handleIncrementStep = incrementStep
  const onSubmit = async data => {
    const newPayload = {
      ...payload,
      ...data
    }
    setPayload(newPayload)
    let canContinue = true
    if (steps[step].handleOnSubmit) {
      const result = await steps[step].handleOnSubmit(newPayload, {
        t,
        property
      })
      if (result.error) {
        canContinue = false
      }
      if (result.data) {
        setPayload({
          ...newPayload,
          ...result.data
        })
      }
    }
    if ((step + 1) !== size(steps)) {
      if (canContinue) {
        handleIncrementStep()
      }
    }
  }
  useEffect(() => {
    if (isUserValid) {
      setPayload({
        name: user.first_name,
        surname: user.last_name,
        email: user.email,
        phone: user.phone_no
      })
      setSteps(filter(steps, step => step.name !== 'user'))
    }
  }, [isUserValid])
  return (
    <div className='flex flex-col h-full lg:items-evenly'>
      <FormComponent
        steps={steps}
        step={step}
        payload={payload}
        error={error}
        incrementStep={handleIncrementStep}
        setError={setError}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default Visit